"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PartialNumberStarRating;

var _react = _interopRequireWildcard(require("react"));

var _StarIcon = _interopRequireDefault(require("../Icons/StarIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function PartialNumberStarRating(_ref) {
  var rating = _ref.rating,
      size = _ref.size;

  var getFullRating = function getFullRating() {
    return Math.floor(rating);
  };

  var getPartialRating = function getPartialRating() {
    return Math.round((rating - Math.floor(rating)) * 100);
  };

  var buildFullStars = function buildFullStars(fullRating) {
    var fullStars = [];

    for (var i = 1; i <= 5; i++) {
      if (fullRating >= i) {
        fullStars.push(_react.default.createElement(_StarIcon.default, {
          variant: "full",
          key: i,
          size: size
        }));
      }
    }

    return fullStars;
  };

  var buildPartialStar = function buildPartialStar(partialRating) {
    if (partialRating < 25) {
      return _react.default.createElement(_StarIcon.default, {
        variant: "empty",
        key: "StarEmpty",
        size: size
      });
    } else if (partialRating >= 25 && partialRating < 50) {
      return _react.default.createElement(_StarIcon.default, {
        variant: "oneQuarter",
        key: "StarOneQuarter",
        size: size
      });
    } else if (partialRating >= 50 && partialRating < 75) {
      return _react.default.createElement(_StarIcon.default, {
        variant: "half",
        key: "StarHalfIcon",
        size: size
      });
    } else {
      return _react.default.createElement(_StarIcon.default, {
        variant: "threeQuarters",
        key: "StarThreeQuarters",
        size: size
      });
    }
  };

  var buildEmptyStars = function buildEmptyStars(starsUsed) {
    var emptyStars = [];

    for (var i = starsUsed; i < 5; i++) {
      emptyStars.push(_react.default.createElement(_StarIcon.default, {
        variant: "empty",
        key: i,
        size: size
      }));
    }

    return emptyStars;
  };

  var buildStars = function buildStars() {
    var stars = buildFullStars(getFullRating());

    if (stars.length < 5) {
      stars.push(buildPartialStar(getPartialRating()));
    }

    stars = stars.concat(buildEmptyStars(stars.length));
    return stars;
  };

  return _react.default.createElement(_react.Fragment, null, buildStars());
}